module.exports = __webpack_public_path__ + "img/home-4-people.7049375a.png";